import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'

const typeOption = [
    { value: 1, label: 'Terlambat' },
    { value: 2, label: 'Pulang Cepat' }
]
const calculationOption = [
    { value: 1, label: 'Tunkin' },
    { value: 2, label: 'Honorarorium' }
]

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            gagal_txt : ''
            
        }
    }


    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }
    checkData = async () => {
        await this.createBloc.fetchCheck(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return 

        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        this.setState({
            gagal_txt: "Gagal!"
        })
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // alert('aaaaaaaaaaaa')
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        this.createBloc.checkChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result.data.response)
                    // this.setState({
                    //     loading: false,
                    //     success: true,
                    // });
                    if(result.data.response==0){
                        this.submitData()
                    }else{
                        this.setState({
                            gagal_txt: "Tanggal Hari Libur Sudah ada",
                            loading: false,
                            failed: true,
                        });
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

       
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Tambah Data Potongan Tunkin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Tambah Potongan Tunkin
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="cutting_category_name"
                                                    placeholder="Nama Potongan..."
                                                    type="text"
                                                    errorMessage="Nama Potongan Wajib diisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="cutting_category_name"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="cutting_category_type"
                                                    errorMessage="Pilih Urutan"
                                                    placeholder="Pilih Urutan"
                                                    options={typeOption}
                                                    isSearchable={false}
                                                    defaultValue={1}
                                                    // isAvForm={false}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jam Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="hour_start"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Jam"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="hour"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="minut_start"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Menit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="minut"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="second_start"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan detik"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="second"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jam Selesai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    name="hour_end"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Jam"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="hour_end"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="minut_end"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan Menit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="minut_end"
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    name="second_end"
                                                    placeholder="00"
                                                    type="number"
                                                    errorMessage="Masukan detik"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="second_end"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Persentase <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="cutting_category_percentage"
                                                    placeholder="Persentase..."
                                                    type="number"
                                                    errorMessage="Persentase Wajib diisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="cutting_category_percentage"
                                                />
                                            </Col>
                                            <Col md="3">%</Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="cutting_category_calculation_type"
                                                    errorMessage="Pilih Urutan"
                                                    placeholder="Pilih Urutan"
                                                    options={calculationOption}
                                                    isSearchable={false}
                                                    defaultValue={1}
                                                    // isAvForm={false}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/potongan_tunkin.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    // failedTitle="Gagal!"
                    failedTitle={this.state.gagal_txt}
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/potongan_tunkin.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView